var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cargo-cascader" },
    [
      _c("el-cascader", {
        ref: "elCascader",
        class: _vm.canCopy ? "can-copy" : "",
        attrs: {
          value: _vm.innerValue,
          disabled: _vm.disabled,
          options: _vm.options,
          filterable: _vm.filterable,
          clearable: "",
          placeholder: _vm.placeholder,
          props: _vm.cascaderProps,
          "show-all-levels": _vm.staticOptions ? true : false
        },
        on: { input: _vm.onInput, change: _vm.onChange },
        nativeOn: {
          keydown: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            $event.preventDefault()
            return _vm.onEnter($event)
          }
        }
      }),
      _vm.canCopy
        ? _c(
            "el-tooltip",
            {
              attrs: {
                content: _vm.$t("CargoMsg.Cargo_Copy"),
                placement: "top"
              }
            },
            [
              _c(
                "el-link",
                {
                  staticClass: "copy-icon",
                  attrs: { underline: false },
                  on: { click: _vm.handleCopy }
                },
                [_c("i", { staticClass: "el-icon-document-copy" })]
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }